(ns assemble.sidebar
  (:require ["@mui/material/Stack$default" :as Stack]
            [assemble.component.file-tree.db :as db]
            [assemble.component.file-tree.view :as tree]
            [re-frame.core :as rf]
            [reitit.frontend.easy :as r.easy]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui sidebar-content [{:keys [type]}]
  (let [{root-folder :value, :keys [initial-pending]} (use-subscribe [:cqrs/get :asset/list-folders])
        type->folders (into {} (map (fn [{:keys [asset-tree/folder-type] :as x}]
                                      [folder-type x])
                                    (:children root-folder)))
        link-context (use-subscribe [:router/path-params])
        parent-node-ids (use-subscribe [:assemble.page.assets.file-tree/parent-node-ids])
        current-node-id (use-subscribe [:assemble.page.assets.file-tree/current-node-id])
        ;; Expanded data-structure is chosen so that collapsing one item also collapses
        ;; its children nodes.
        expanded (use-subscribe [::db/expanded])
        toggle #(rf/dispatch [::db/toggle-expanded %])]
    (uix/use-effect (fn []
                      (rf/dispatch [::db/add-expanded (rest parent-node-ids)]))
                    [parent-node-ids])
    ($ tree/file-tree-context
       {:selected current-node-id
        :expanded expanded
        :toggle toggle
        :node->id :asset-tree/id
        :node->label (fn [node]
                       (:asset-tree/name node))}
       ($ Stack
          {:direction "column"
           :flex 1}
          (if initial-pending
            ($ tree/tree-skeleton)
            (case type
              :assets ($ tree/tree-item
                         {:node (get type->folders "assets")
                          :href (r.easy/href :advertiser/assets link-context)})
              :templates ($ tree/tree-item
                            {:node (get type->folders "templates")
                             :href (r.easy/href :advertiser/templates link-context)})
              :fonts ($ tree/tree-item
                        {:node (get type->folders "fonts")
                         :href (r.easy/href :advertiser/brand-kit link-context {:node (:asset-tree/id (get type->folders "fonts"))})})
              :logos ($ tree/tree-item
                        {:node (get type->folders "logos")
                         :href (r.easy/href :advertiser/brand-kit link-context {:node (:asset-tree/id (get type->folders "logos"))})})
              ($ tree/tree-skeleton)))))))
